module.exports = __webpack_public_path__ + "static/img/shl_game_live_qr_code.bf7664c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_game_live_qr_code.jpeg
// module id = JXq8
// module chunks = 5